/* Ajout rapide au panier depuis les cartes produits (snippets/quick-add-options.liquid).
   Tailles autorisées par forme : reproduit le modèle standard de King Product Options,
   relevé sur la fiche produit le 03/10/2026. Si Julia change ces règles dans King,
   les reporter ici. */
(function () {
  var ALLOWED = {
    'Ovale': ['XXS', 'XS'],
    'Amande': ['S', 'M', 'L'],
    'Stiletto': ['L', 'XL'],
    'Coffin': ['S', 'M', 'L', 'XL'],
    'Carré': ['XS', 'S', 'M', 'L', 'XL']
  };

  function parts(form) {
    return {
      forme: form.querySelector('[data-quick-add-forme]'),
      taille: form.querySelector('[data-quick-add-taille]'),
      hint: form.querySelector('[data-quick-add-hint]'),
      btn: form.querySelector('[data-quick-add-btn]')
    };
  }

  function syncSizes(form) {
    var p = parts(form);
    var ok = ALLOWED[p.forme.value];
    Array.prototype.forEach.call(p.taille.options, function (o) {
      if (!o.value) return;
      o.disabled = Boolean(ok) && ok.indexOf(o.value) === -1;
    });
    if (p.taille.selectedOptions[0] && p.taille.selectedOptions[0].disabled) p.taille.value = '';
  }

  function clearError(form) {
    var p = parts(form);
    p.forme.parentNode.classList.remove('is-missing');
    p.taille.parentNode.classList.remove('is-missing');
    p.hint.textContent = '';
  }

  // Ouvre le tiroir panier du thème (réglage cart_type = drawer) : même événement que l'ajout AJAX du thème
  function openCart(btn, item) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
  }

  function addToCart(variantId, forme, taille) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { 'Formes': forme, 'Taille': taille } }] })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || r.data.message || 'Ajout impossible');
        return r.data.items ? r.data.items[0] : r.data;
      });
  }

  /* ---------- Téléphone : bouton + sur la photo, panneau en bas ---------- */

  var FORMES = Object.keys(ALLOWED);
  var TAILLES = ['XXS', 'XS', 'S', 'M', 'L', 'XL'];
  var sheet = null;
  var current = null;
  var lastFocus = null;

  // Pose chaque bouton + sur la photo de sa carte (le lien produit l'entoure : le clic est intercepté)
  function placePlusButtons(root) {
    (root || document).querySelectorAll('[data-quick-add-open]:not([data-placed])').forEach(function (btn) {
      var card = btn.closest('.grid-product__content');
      var mask = card && card.querySelector('.grid-product__image-mask');
      if (!mask) return;
      mask.appendChild(btn);
      btn.setAttribute('data-placed', '');
    });
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'qa-sheet';
    sheet.hidden = true;
    sheet.innerHTML = '<div class="qa-sheet__scrim" data-qa-close></div>' +
      '<div class="qa-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="qa-sheet-title">' +
      '<div class="qa-sheet__top"><img class="qa-sheet__img" alt=""><div><div class="qa-sheet__title" id="qa-sheet-title"></div><div class="qa-sheet__price"></div></div>' +
      '<button type="button" class="qa-sheet__x" data-qa-close aria-label="Fermer">&times;</button></div>' +
      '<div class="qa-sheet__grp"><div class="qa-sheet__hd">Forme</div><div class="qa-sheet__chips" data-qa-group="forme">' +
      FORMES.map(function (f) { return '<button type="button" class="qa-chip" aria-pressed="false">' + esc(f) + '</button>'; }).join('') + '</div></div>' +
      '<div class="qa-sheet__grp"><div class="qa-sheet__hd">Taille <a class="qa-sheet__guide">Guide des tailles</a></div><div class="qa-sheet__chips" data-qa-group="taille">' +
      TAILLES.map(function (t) { return '<button type="button" class="qa-chip" aria-pressed="false">' + t + '</button>'; }).join('') + '</div></div>' +
      '<p class="qa-sheet__hint" aria-live="polite"></p>' +
      '<button type="button" class="btn btn--full qa-sheet__add" data-qa-add></button>' +
      '</div>';
    document.body.appendChild(sheet);

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-qa-close]')) return closeSheet();
      var chip = e.target.closest('.qa-chip');
      if (chip && !chip.disabled) {
        var group = chip.parentNode.dataset.qaGroup;
        chip.parentNode.querySelectorAll('.qa-chip').forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        current[group] = chip.textContent;
        if (group === 'forme') syncSheetSizes();
        sheet.querySelector('.qa-sheet__hint').textContent = '';
        return;
      }
      if (e.target.closest('[data-qa-add]')) submitSheet(e.target.closest('[data-qa-add]'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
    });
  }

  function syncSheetSizes() {
    var ok = ALLOWED[current.forme];
    sheet.querySelectorAll('[data-qa-group="taille"] .qa-chip').forEach(function (c) {
      var allowed = !ok || ok.indexOf(c.textContent) !== -1;
      c.disabled = !allowed;
      if (!allowed && current.taille === c.textContent) {
        current.taille = null;
        c.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function openSheet(btn) {
    if (!sheet) buildSheet();
    lastFocus = btn;
    current = { variantId: btn.dataset.variantId, forme: null, taille: null };
    var img = sheet.querySelector('.qa-sheet__img');
    img.src = btn.dataset.image || '';
    img.hidden = !btn.dataset.image;
    sheet.querySelector('.qa-sheet__title').textContent = btn.dataset.title;
    sheet.querySelector('.qa-sheet__price').textContent = btn.dataset.price;
    sheet.querySelector('.qa-sheet__guide').href = btn.dataset.url;
    sheet.querySelector('.qa-sheet__hint').textContent = '';
    var add = sheet.querySelector('[data-qa-add]');
    add.textContent = 'Ajouter au panier · ' + btn.dataset.price;
    add.disabled = false;
    sheet.querySelectorAll('.qa-chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); c.disabled = false; });
    sheet.hidden = false;
    document.documentElement.classList.add('qa-sheet-open');
    sheet.querySelector('.qa-chip').focus();
  }

  function closeSheet() {
    sheet.hidden = true;
    document.documentElement.classList.remove('qa-sheet-open');
    if (lastFocus) lastFocus.focus();
  }

  function submitSheet(addBtn) {
    var hint = sheet.querySelector('.qa-sheet__hint');
    var miss = [];
    if (!current.forme) miss.push('une forme');
    if (!current.taille) miss.push('une taille');
    if (miss.length) { hint.textContent = 'Choisis ' + miss.join(' et '); return; }
    addBtn.disabled = true;
    addToCart(current.variantId, current.forme, current.taille)
      .then(function (item) {
        closeSheet();
        openCart(addBtn, item);
      })
      .catch(function (err) { hint.textContent = err.message; addBtn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-quick-add-open]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    openSheet(btn);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { placePlusButtons(); });
  else placePlusButtons();
  // Sections chargées après coup (carrousels, éditeur de thème)
  new MutationObserver(function () { placePlusButtons(); }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-quick-add]');
    if (!form) return;
    if (e.target.matches('[data-quick-add-forme]')) syncSizes(form);
    clearError(form);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var p = parts(form);
    var miss = [];
    if (!p.forme.value) { p.forme.parentNode.classList.add('is-missing'); miss.push('une forme'); }
    if (!p.taille.value) { p.taille.parentNode.classList.add('is-missing'); miss.push('une taille'); }
    if (miss.length) { p.hint.textContent = 'Choisis ' + miss.join(' et '); return; }

    p.btn.disabled = true;
    addToCart(form.dataset.variantId, p.forme.value, p.taille.value)
      .then(function (item) {
        form.classList.add('is-added');
        setTimeout(function () { form.classList.remove('is-added'); }, 1800);
        openCart(p.btn, item);
      })
      .catch(function (err) { p.hint.textContent = err.message; })
      .then(function () { p.btn.disabled = false; });
  });
})();
